import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import IAuthorizationData from "../../../core/src/server/data/IAuthorizationData";

import GameModel from "../../../core/src/model/GameModel";
import JackpotsModel from "../../model/JackpotsModel";
import App from "../../../core/src/App";
import GameEvents from "../../../core/src/const/GameEvents";
import BetModel from "../../../core/src/model/BetModel";

export default class SessionDataParser
    implements IBaseDataParser<IAuthorizationData> {
    check(data: any): boolean {
        return data?.data?.sessionId;
    }

    parse(data): IAuthorizationData[] {
        if (!GameModel.gameConfig.hasJackpotsFeature) {
            data.data.jackpots = null;
        };

        if (data.request === "createSession") {
            if (data.data.jackpots !== null) {
                if (data.data.jackpotFee) {
                    JackpotsModel.jackpotFee = data.data.jackpotFee;
                }

                JackpotsModel.jackpotsAvailable = true;
                let priorityList = [
                    // Custom jackpots will have priority 0
                    {id: "mini", priority: 1},
                    {id: "minor", priority: 2},
                    {id: "major", priority: 3},
                    {id: "grand", priority: 4},
                ];

                let list = [];
                data.data.jackpots.forEach(jackpot => {
                    let item = priorityList.find(x => { return x.id == jackpot.id });
                    let priority = 0;
                    if (item) {
                        priority = item.priority;
                    }

                    list.push({ id: jackpot.id, priority: priority, name: jackpot.name });
                });

                // Defines the priority ordering
                let ascending = false;

                let sorted = list.sort((a, b) => {
                    if (ascending) {
                        return a.priority - b.priority;
                    }

                    return b.priority - a.priority;
                });

                JackpotsModel.jackpotNames = sorted.map(x => x.name);
            } else {
                JackpotsModel.jackpotsAvailable = false;
            };
            
            if (data.data.lastBet) {
                BetModel.lastBet = +data.data.lastBet;
            }

            if (data.data.error == 0) {
                App.dispatcher.emit(GameEvents.SESSION_CREATED);
            }
        };

        const result: IAuthorizationData = {
            sessionID: data.data.sessionId
        };

        return [result];
    }


}
